import { BlockComponentModel } from '@/cms/types/blok-component';
import {
  BackgroundImageHeroLink,
  HeroWithBackgroundImage,
} from '@/decodo/blocks/BackgroundImageHero';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

export type HeroWithBackgroundProps = {
  title: string;
  description: RichTextFieldStrapiProps;
  links: LinkButtonStrapiProps[];
};

export function HeroWithBackgroundStrapi({
  block,
}: BlockComponentModel<HeroWithBackgroundProps>) {
  const { title, description, links } = block;

  function getBannerButtons(
    links: LinkButtonStrapiProps[]
  ): BackgroundImageHeroLink[] {
    const paths = links
      ?.map((item) => ({
        href: item.url,
        label: item.text,
      }))
      .filter((link): link is BackgroundImageHeroLink => !!link.label);

    return paths;
  }
  const transformedButtons = getBannerButtons(links) || [];

  return (
    <HeroWithBackgroundImage
      links={transformedButtons}
      title={title}
      description={
        <RichTextFieldStrapi
          block={description}
          classNames={{ link: { root: 'text-body-l sm:text-blog-body' } }}
        />
      }
    />
  );
}
